import * as Telecom from '@servicetitan/telecom-rtcs-client';
import { userStatsFromAgentStats } from '../../types/ServiceUser';
import appManager from '@app/appManager';
import {
  ServiceSessionEventType,
  ServiceSessionUserEvent,
} from '../../types/ServiceEvents';
import requireUser from '../../lib/requireUser';
import log from '../../lib/log';
import isValidUser from '../../lib/isValidUser';
import { ServiceUserUtils } from '../../lib/serviceUserUtils';
import { RTCSEventType } from '../../../metrics/rtcsMetrics';
import { trackRTCSEventLatency } from '../../lib/trackRTCSEventLatency';

/**
 * The reject event indicates that a recipient has rejected a call.
 * @param event
 */
async function handleAgentSessionRejected(
  event: Telecom.AgentSessionRejectedEvent,
) {
  trackRTCSEventLatency(event.timestamp, RTCSEventType.SESSION_REJECTED);

  if (!isValidUser(event.agentId)) {
    return;
  }

  const user = await requireUser(event.agentId);
  log('rtcs:agent:session_rejected:' + user?.name, event);

  user.stats = userStatsFromAgentStats(event.stats);

  ServiceUserUtils.setEventActivityStatus(user, '');

  appManager.events.emit<ServiceSessionUserEvent>(
    ServiceSessionEventType.REJECTED,
    {
      sessionId: event.conversationId,
      sessionSid: event.conversationSid,
      agentId: event.agentId,
      userId: user.id,
    },
  );
}

export default handleAgentSessionRejected;
